import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import { getAppropriateUrl } from '@invideoio/web-shared/utils/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { BottomSection } from '../../types/landing-page';
import Detail from './Detail';
import Title from './Title';

interface PromotionProps {
  promotionSection: BottomSection;
  platform: PlatformType;
  browser: BrowserType;
  onSignUp: Function;
}

const promotionImageSize: Record<
  PlatformType,
  { width: number; height: number }
> = {
  desktop: { width: 1043, height: 650 },
  tablet: { width: 598, height: 433 },
  mobile: { width: 500, height: 312 },
};

const PromotionSection = (props: PromotionProps) => {
  const { promotionSection, platform, browser, onSignUp } = props;
  const {
    heading,
    sideText,
    buttonText,
    subText,
    poster,
    CTAUrl,
    MobileAppLink,
  } = promotionSection;
  const { heading1, heading2, heading3 } = heading;
  const { highlightedText, plainText1 } = sideText;

  const imageUrl = getAppropriateUrl(poster.url, browser, platform);

  const { width, height } = promotionImageSize[platform];

  return (
    <section
      className={ivclass(
        'iv-mt-200 lg:iv-mt-150 md:iv-mt-100 sm:iv-mt-75',
        'sm:iv-pt-64 md:iv-pt-100 lg:iv-pt-[91px] xl:iv-pt-[137px]',
        'lg:iv-px-40',
        'iv-bg-grey-100',
        'iv-text-grey-0',
        'iv-overflow-hidden',
      )}
    >
      <div className={ivclass('iv-container', 'iv-mx-auto')}>
        <div
          className={ivclass(
            'iv-grid',
            'sm:iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12',
            'sm:iv-gap-20 md:iv-gap-25 lg:iv-gap-40 xl:iv-gap-40',
          )}
        >
          <div
            className={ivclass(
              'sm:iv-col-span-4 md:iv-col-span-8 lg:iv-col-start-2 lg:iv-col-span-11 xl:iv-col-start-2 xl:iv-col-span-11',
            )}
          >
            <div
              className={ivclass(
                'sm:iv-pb-40 md:iv-pb-[55px] lg:iv-pb-80 xl:iv-pb-80',
                'sm:iv-pt-10',
                'sm:iv-px-30 md:iv-px-60',
              )}
            >
              <Title
                plainTitle={{ line1: heading1, line2: heading2 }}
                highlightedTitle={heading3}
              />
            </div>
          </div>
        </div>
        <div className={ivclass('sm:iv-px-30 md:iv-px-60')}>
          <div
            className={ivclass(
              'iv-grid',
              'sm:iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12',
              'md:iv-gap-25 lg:iv-gap-40 xl:iv-gap-40',
            )}
          >
            <div
              className={ivclass(
                'sm:iv-col-span-4 md:iv-col-span-3 lg:iv-col-start-2 lg:iv-col-end-6 xl:iv-col-start-2 xl:iv-col-end-6',
                'sm:iv-pb-35',
                'sm:iv-text-center md:iv-text-left lg:iv-text-left xl:iv-text-left',
              )}
            >
              <Detail
                paragraph={plainText1}
                highlightedParagraph={highlightedText}
                buttonLabel={buttonText}
                subInfo={subText}
                link={CTAUrl}
                MobileAppLink={MobileAppLink}
                onSignUp={onSignUp}
              />
            </div>
            <div
              className={ivclass(
                'iv-relative',
                'sm:iv-col-span-4 md:iv-col-span-5 lg:iv-col-span-7 xl:iv-col-span-7',
                'sm:iv-h-[312px] md:iv-h-[433px] lg:iv-h-[538px] xl:iv-h-[650px]',
              )}
            >
              <div className={ivclass('iv-promotion-img')}>
                <div className={ivclass('iv-relative', 'iv-w-full iv-h-full')}>
                  <ImageComponent
                    elementype="native"
                    src={imageUrl}
                    alt={poster.alternativeText}
                    className="iv-object-contain"
                    width={width}
                    height={height}
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionSection;
